import React from 'react';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { FADownloadIcon } from '@components';
import { ButtonV2, IconButtonV2 } from 'components/common/ui';
import { useExportFile } from '@hooks';
import { Tooltip } from 'components/common/modals';

export default function ExportButton({
  onExportRequest,
  fileName = 'downloaded file',
  fileType = 'text/csv',
  onlyIcon = false,
  text = 'Export',
  disabled = false,
  size = 'large',
  isIconButton = false,
  ...rest
}) {
  const { exporting, handleExportFile } = useExportFile(
    onExportRequest,
    fileName,
    fileType
  );

  return isIconButton ? (
    <IconButtonV2
      variant="text"
      size="small"
      onClick={handleExportFile}
      disabled={disabled || exporting}
      {...rest}
    >
      <Tooltip title="Export" placement="top">
        <FileDownloadIcon fontSize="small" />
      </Tooltip>
    </IconButtonV2>
  ) : (
    <ButtonV2
      loading={exporting}
      variant="secondary"
      onClick={handleExportFile}
      disabled={disabled}
      size={size}
      {...rest}
    >
      {!exporting && <FADownloadIcon />}
      {!onlyIcon && text}
    </ButtonV2>
  );
}
